import clsx from 'clsx';
import { ChevronRight } from 'lucide-react';
import Link from 'next/link';
import { Heading } from '@//components/Heading';
import styles from './Section.module.scss';

interface SectionProps {
  id: string;
  heading: string;
  headingLevel?: 1 | 2 | 3 | 4 | 5 | 6;
  children: React.ReactNode;
  link?: {
    href: string;
    title: string;
    ariaLabel?: string;
  };
  description?: string;
  className?: string;
}

export const Section: React.FC<SectionProps> = ({
  id,
  heading,
  headingLevel = 2,
  children,
  link,
  description,
  className,
}) => {
  const headingId = `${id}-heading`;
  const descriptionId = `${id}-description`;

  return (
    <section
      className={clsx(styles.section, className)}
      aria-labelledby={headingId}
      aria-describedby={description ? descriptionId : undefined}
    >
      <header className={styles.header}>
        {link ? (
          <Link
            href={link.href}
            aria-label={link.ariaLabel || link.title}
            className={styles.headingLink}
          >
            <Heading level={headingLevel} size="xl" id={headingId} className={styles.headingText}>
              {heading}
              <span className={styles.headingIcon} aria-hidden="true">
                <ChevronRight aria-hidden="true" />
              </span>
            </Heading>
          </Link>
        ) : (
          <Heading level={headingLevel} size="xl" id={headingId}>
            {heading}
          </Heading>
        )}
        {description && (
          <p className={styles.description} id={descriptionId}>
            {description}
          </p>
        )}
      </header>
      {children}
    </section>
  );
};
